import { httpRequest } from "../../http";
import { MediaFile } from "@models/mediaFile.model";

export class CommandGetMedia {
    async run(mediaId: number): Promise<MediaFile> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/media/${mediaId}/`;
        try {
            const response = await httpRequest<MediaFile>(url, { method: "GET" });
            return response;
        } catch (error) {
            console.error("Error fetching media:", error);
            throw error;
        }
    }
}
